import { api } from ":mods";
import { ENDPOINTS } from "../../const";

export async function putTaskDetails(id:string|number,collection_id:string|number,data, isForm=true) {
  const collection = `?collection=${collection_id}`
  const multipart =  {
    "Content-Type": "multipart/form-data",
  }
      return api
        .putAuth(ENDPOINTS.material_details_with_material_id_student + id+"/" + collection, data, {
          headers: isForm ? multipart: {},
        })
        .then(async (res) => {
          return Promise.resolve(res.data);
        })
        .catch((err) => {
          return Promise.reject(err);
        });

    }